import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CertificateService } from 'src/app/services/certificate.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  constructor(private svc: CertificateService, public route: ActivatedRoute, private router: Router, private state: StateService) { }

  ngOnInit(): void {
    if (!this.route.snapshot.queryParams.key) {
      if (!this.state.user) {
        this.checkLogin();
      } else {
        this.router.navigate(['/issue']);
      }
    } else {
      this.svc.setCertKey(this.route.snapshot.queryParams.key).subscribe(_ => this.checkLogin());
    }
  }

  private checkLogin() {
    this.state.getUserInfo().subscribe({
      next: (x) => {
        if (!x) {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['/issue']);
        }
      },
      error: (_) => this.router.navigate(['/login'])
    });
  }
}
